import { api } from '../api-client.config';
import { apiEndpoints } from '../endpoints';

export interface TranslateTextRequest {
  text: string;
  from?: string;
  to?: string;
}

export interface TranslateTextResponse {
  translation: string;
  skipped: boolean;
  reason?: string;
}

export const translateText = async ({
  text,
  from = 'en',
  to = 'fr-ca',
}: TranslateTextRequest): Promise<TranslateTextResponse> => {
  return api.post(apiEndpoints.translate, { text, from, to });
};
